import type { NotificationData } from '~/core/services/signalRService';

export interface DataRefreshState {
  hasNewData: boolean;
  objectType: string;
  message: string;
  timestamp: string;
  notification?: NotificationData;
}

// Global state cho từng object type
const refreshStates = ref<Record<string, DataRefreshState>>({});

export const useDataRefresh = (objectType: string) => {
  // Get state cho object type cụ thể
  const refreshState = computed(() => 
    refreshStates.value[objectType] || {
      hasNewData: false,
      objectType,
      message: '',
      timestamp: '',
      notification: undefined
    }
  );

  // Set new data notification
  const setNewDataNotification = (notification: NotificationData) => {
    
    if(notification.objectType?.toLowerCase().includes('student')) {
      refreshStates.value[objectType] = {
        hasNewData: true,
        objectType,
        message: notification.message || 'Có dữ liệu mới',
        timestamp: new Date().toISOString(),
        notification
      };
    }
  };

  // Clear notification 
  const clearNewDataNotification = () => {
    if (refreshStates.value[objectType]) {
      refreshStates.value[objectType].hasNewData = false;
    }
  };

  // Reset toàn bộ state
  const resetRefreshState = () => {
    delete refreshStates.value[objectType];
  };

  return {
    refreshState: readonly(refreshState),
    setNewDataNotification,
    clearNewDataNotification,
    resetRefreshState
  };
}; 